export const APP_CONFIG = {
  name: 'Haist',
  url: 'https://getautohos.com',
  social: {
    threads: 'https://www.threads.com/@auto.hos',
    instagram: 'https://www.instagram.com/auto.hos/',
    tiktok: 'https://www.tiktok.com/@auto.hos',
  },
  contact: {
    email: 'key.eu@datium.xyz',
    cc: [
      'sangho.park@datium.xyz',
      'jini.kim@datium.xyz',
      'steve.park@datium.xyz',
    ], // Add CC recipients here
  },
  download: {
    ios: 'https://apps.apple.com/us/app/haist/id6755947864',
    android: 'https://play.google.com/store/apps/details?id=xyz.datium.haist',
  },
} as const;
